// extracted by mini-css-extract-plugin
export default {"auth__container":"sign-in_auth__container__s++Bn","auth__title":"sign-in_auth__title__fzE1m","auth__box":"sign-in_auth__box__SIivl"};